import { render, staticRenderFns } from "./AccessSuccess.vue?vue&type=template&id=19667a92&scoped=true"
import script from "./AccessSuccess.vue?vue&type=script&lang=js"
export * from "./AccessSuccess.vue?vue&type=script&lang=js"
import style0 from "./AccessSuccess.vue?vue&type=style&index=0&id=19667a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19667a92",
  null
  
)

export default component.exports